import React from 'react';

interface RecordFooterProps {
  table: any;                // instancia de react-table
  footerContent?: React.ReactNode; // contenido a renderizar en el pie
  actions?: boolean;         // si hay una columna extra de acciones
}

const RecordFooter: React.FC<RecordFooterProps> = ({ table, footerContent, actions }) => {
  const headerGroup = table?.headerGroups?.[0];
  const renderedColumns = headerGroup?.headers?.length || 1;
  const colSpan = actions ? renderedColumns + 1 : renderedColumns;

  return (
    <tfoot>
      <tr className="bg-gray-50 dark:bg-gray-800 border-t border-stroke dark:border-strokedark">
        <td colSpan={colSpan} className="px-6 pt-6">
          <div className="flex justify-end">
            {footerContent ? (
              footerContent
            ) : (
              <span className="text-gray-500 dark:text-gray-400 text-sm">
                {/* Mensaje por defecto si no se pasa nada */}
                No hay totales para mostrar.
              </span>
            )}
          </div>
        </td>
      </tr>
    </tfoot>
  );
};

export default RecordFooter;
